import { AuthActions } from './constant';

const {
  THERAPIST_LOGIN_REQUEST,
  THERAPIST_LOGOUT_REQUEST,
  THERAPIST_LOGIN_RESET,
  THERAPIST_LOGOUT_RESET,
  THERAPIST_LOGOUT_SUCCESS,
  REQUEST_SET_PASSWORD,
  RESET_SET_PASSWORD,
  AUTO_GENERATE_PASSWORD,
  POST_RESET_PASSWORD_RESET,
  POST_RESET_PASSWORD_REQUEST,
} = AuthActions;

export const therapistLogin = (payload: object, subdomain: string, isProfile: boolean = true) => {
  return {
    type: THERAPIST_LOGIN_REQUEST,
    payload,
    subdomain,
    isProfile,
  };
};

export const therapistLogout = (payload: object, subdomain:string) => {
  return {
    type: THERAPIST_LOGOUT_REQUEST,
    payload,
    subdomain,
  };
};

export const resetTherapistLogin = () => {
  return {
    type: THERAPIST_LOGIN_RESET,
  };
};

export const resetTherapistLogout = () => {
  return {
    type: THERAPIST_LOGOUT_RESET,
  };
};

export const therapistLogoutAction = () => {
  return {
    type: THERAPIST_LOGOUT_SUCCESS,
  };
};

export const setPasswordAction = (payload: object) => {
  return {
    type: REQUEST_SET_PASSWORD,
    payload,
  };
};

export const resetSetPassword = () => {
  return {
    type: RESET_SET_PASSWORD,
  };
};

export const autoGeneratePassword = () => {
  return {
    type: AUTO_GENERATE_PASSWORD,
  };
};

export const postResetPasswordAction = (payload: object) => {
  return {
    type: POST_RESET_PASSWORD_REQUEST,
    payload,
  };
};

export const PostResetPasswordResetState = () => {
  return {
    type: POST_RESET_PASSWORD_RESET,
  };
};